import { render, staticRenderFns } from "./_PopulasiProduksi.vue?vue&type=template&id=20eb3896&"
import script from "./_PopulasiProduksi.vue?vue&type=script&lang=js&"
export * from "./_PopulasiProduksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports